var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-table',{attrs:{"fields":_vm.fields,"items":_vm.numbers,"show_header":true,"show_pagination_description":false,"show_per_page":false}},[_c('template',{slot:"actions"},[_c('table-control',{attrs:{"type":"trash"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }